var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { "data-vv-scope": "step-3-part-1" } }, [
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("h5", { staticClass: "mb-0" }, [_vm._v("Adjuntar Documentos")]),
            _c("LoadFiles", {
              attrs: { withClassification: "", step: _vm.step },
              on: {
                mainFile: function($event) {
                  return _vm.addMainFile($event)
                },
                additionalFiles: function($event) {
                  return _vm.addAdditionalFile($event)
                }
              }
            })
          ],
          1
        ),
        _vm.error.noMainFile
          ? _c("small", { staticClass: "text-danger mt-1 ml-5" }, [
              _vm._v(_vm._s(_vm.error.noMainFile))
            ])
          : _vm._e(),
        _vm.error.onlyPdf
          ? _c("small", { staticClass: "text-danger mt-1 ml-5" }, [
              _vm._v(_vm._s(_vm.error.onlyPdf))
            ])
          : _vm._e()
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
      ])
    ]),
    _c("form", { attrs: { "data-vv-scope": "step-3-part-2" } }, [
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "vs-select",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Relacionado con",
                  name: "relatedDocumentType",
                  danger: _vm.errors.has("step-3-part-2.relatedDocumentType"),
                  "danger-text": _vm.errors.first(
                    "step-3-part-2.relatedDocumentType"
                  )
                },
                model: {
                  value: _vm.relatedDocument.type,
                  callback: function($$v) {
                    _vm.$set(_vm.relatedDocument, "type", $$v)
                  },
                  expression: "relatedDocument.type"
                }
              },
              [
                _c("vs-select-item", {
                  attrs: { value: "EXP", text: "Expediente" }
                }),
                _c("vs-select-item", {
                  attrs: { value: "SSD", text: "Proceso SSD" }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-100",
              attrs: {
                label: "Nº Documento",
                name: "relatedDocumentNumber",
                danger: _vm.errors.has("step-3-part-2.relatedDocumentNumber"),
                "danger-text": _vm.errors.first(
                  "step-3-part-2.relatedDocumentNumber"
                )
              },
              model: {
                value: _vm.relatedDocument.number,
                callback: function($$v) {
                  _vm.$set(_vm.relatedDocument, "number", $$v)
                },
                expression: "relatedDocument.number"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12 d-flex align-items-end justify-content-end" },
          [
            _c(
              "vs-button",
              {
                attrs: { color: "primary", icon: "add" },
                on: {
                  click: function($event) {
                    return _vm.addRelatedDocument()
                  }
                }
              },
              [_vm._v(" Agregar relación ")]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "vs-table",
              {
                staticClass: "pb-2 mb-2",
                attrs: {
                  multiple: "",
                  "no-data-text": "No tienes documentos relacionados",
                  data: _vm.step.relatedDocuments
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var data = ref.data
                      return _vm._l(data, function(tr, indextr) {
                        return _c(
                          "vs-tr",
                          { key: indextr, attrs: { data: tr } },
                          [
                            _c(
                              "vs-td",
                              { attrs: { data: data[indextr].type } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.findTypeDocument(tr.type)) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "vs-td",
                              { attrs: { data: data[indextr].number } },
                              [_vm._v(" " + _vm._s(tr.number) + " ")]
                            )
                          ],
                          1
                        )
                      })
                    }
                  }
                ]),
                model: {
                  value: _vm.step.relatedDocumentsSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "relatedDocumentsSelected", $$v)
                  },
                  expression: "step.relatedDocumentsSelected"
                }
              },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", [_vm._v("Relacionado con")]),
                    _c("vs-th", [_vm._v("Nº Documento")])
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }